import { OAuthClientType } from 'features/developers/types'
import { CommonPrivacy, CommonSharingScope } from 'features/common'
import { Group } from 'features/groups/types'

export enum PrivateAppTypes {
  spa = 'spa',
  non_interactive = 'non_interactive',
  regular_web = 'regular_web'
}
export enum PrivateAppTokenMethod {
  basic = 'client_secret_basic',
  post = 'client_secret_post',
  none = 'none'
}

export enum AppTypes {
  Private = 'private',
  Listed = 'listed'
}

export enum AppShare {
  Private = 'private',
  SharedWithAll = 'all',
  SharedWithGroups = 'groups'
}

export interface App {
  id?: string
  title: string
  description: string
  url: string
  thumbnail_url: string
  user_id: string
  updated_at: number
  created_at: number
  type: AppTypes

  app_type: OAuthClientType
  token_endpoint_auth_method: string
  initiate_login_uri: string
  callbacks: string
  allowed_logout_urls: string
  web_origins: string // Comma-separated list of allowed origins for use with Cross-Origin Authentication, Device Flow, and web message response mode.
  allowed_origins: string // Comma-separated list of URLs allowed to make requests from JavaScript to Auth0 API (typically used with CORS). By default, all your callback URLs will be allowed.
  domain: string
  client_secret: string
  client_id: string
  image: string
  bookmarked?: boolean
  privacy?: CommonPrivacy.Shared | CommonPrivacy.Private
  groups?: string[] | Group[]
  sharingScope?: CommonSharingScope
}

export type AppPayload = Omit<App, 'id' | 'type'>

export interface AppsListFilter {
  searchBy?: string
  orderBy: {
    fieldName: string
    ascending: boolean
  }
}

interface FeaturedAppDescription {
  main?: string
  notes?: string
}

export interface FeaturedAppMeta {
  country?: string
  industry?: string
  use_case?: string
  featured_partner?: string
  credentials?: string
}

export interface FeaturedAppMainContent {
  logo_url: string
  app_url?: string
  video_url?: string
  background_url?: string
  card_header_url?: string
}

export interface FeaturedApp {
  id?: string
  title: string
  order?: number
  description: FeaturedAppDescription
  meta: FeaturedAppMeta
  main_content: FeaturedAppMainContent
  media: string[]
}

export type PatchAppParams = Pick<App, 'id'> & Partial<Pick<App, 'privacy' | 'groups' | 'sharingScope'>>
